import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["studentsInput", "classroomsInput", "addBtnStudents", "addBtnClassrooms", "form"]
  static values = {
    studentPresence: Boolean
  }
  formTargetConnected() {
    this.initializeFormValidation()
  }

  initializeFormValidation() {
    let $studentSelect = $("#observation_ids_student")
    let $classroomSelect = $("#observation_classroom_ids")

    var validationObject = $(this.formTarget).validate({
      rules: {
        "observation[category]": {
          required: true
        },
        "observation[obs_color]": {
          required: true
        },
        "observation[ids_student][]": {
          required: this.#studentsSelectRequiredRule($studentSelect, $classroomSelect)
        },
        "observation[classroom_ids][]": {
          required: this.#classroomsSelectRequiredRule($classroomSelect)
        }
      },
      ignore: null,
      errorPlacement: function(error, element) {
        if (element[0].name === "observation[ids_student][]" ||
          element[0].name === "observation[classroom_ids][]") {
          element.parent().parent().parent().append(error)
          document.querySelector("#add-btn-students").scrollIntoView({ behavior: "smooth", block: "end" })
        }
        else {
          element.parent().parent().append(error)
        }
      },
      errorElement: "div"
    });

    $studentSelect.on("change", function() {
      if (!this.#emptySelection($studentSelect)) {
        $studentSelect.rules("remove", "required")
      }
      else {
        $studentSelect.rules("add", {
          required: this.#studentsSelectRequiredRule($studentSelect, $classroomSelect)
        })
      }
      validationObject.form()
    }.bind(this))

    $classroomSelect.on("change", function() {
      if (!this.#emptySelection($classroomSelect)) {
        $classroomSelect.rules("remove", "required")
        $studentSelect.rules("remove", "required")
      }
      else {
        $classroomSelect.rules("add", {
          required: this.#classroomsSelectRequiredRule($classroomSelect)
        })
      }
      validationObject.form()
    }.bind(this))
  }
  // private methods
  #studentsSelectRequiredRule(studentSelect, classroomSelect) {
    if (this.hasStudentsInputTarget) {
      return (this.studentsInputTarget.checkVisibility() || (!this.studentsInputTarget.checkVisibility() && !this.classroomsInputTarget.checkVisibility())) && this.#emptySelection(studentSelect) && this.#emptySelection(classroomSelect) && !this.studentPresenceValue
    }
    else {
      return false
    }
  }

  #classroomsSelectRequiredRule(classroomSelect) {
    if (this.hasClassroomsInputTarget) {
      return this.classroomsInputTarget.checkVisibility() && !this.studentsInputTarget.checkVisibility() && this.#emptySelection(classroomSelect) && !this.studentPresenceValue
    }
    else {
      return false
    }
  }

  #emptySelection(select) {
    return select.select2("data").length == 0
  }
}
